// useUrlTab.js
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Hook para sincronizar o estado de uma aba com a URL (via query param).
 *
 * Uso:
 *   const tab = useUrlTab("tab", "tabDados");
 *   tab.value  -> aba ativa
 *   tab.set("tabEnderecos") -> muda aba
 */
export function useUrlTabModule(
  paramName = "tab",
  defaultValue = "tabDefault"
) {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const initialValue: string = params.get(paramName) ?? defaultValue;

  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    const newParams = new URLSearchParams(location.search);
    newParams.set(paramName, value);

    // Atualiza a URL sem recarregar e sem criar histórico
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  }, [value, navigate, location.pathname, paramName]);

  return {
    value,
    set: (val: string | null) => {
      if (val) setValue(val);
    },
  };
}
